import { Flex, Link, RadioCards, Text } from '@workos-inc/design-system';
import * as React from 'react';
import { DotNetLogoIcon } from 'src/icons/dotnet-logo-icon';
import { GoLogoIcon } from 'src/icons/go-logo-icon';
import { JavaLogoIcon } from 'src/icons/java-logo-icon';
import { LaravelLogoIcon } from 'src/icons/laravel-logo-icon';
import { NodeJsLogoIcon } from 'src/icons/nodejs-logo-icon';
import { PhpLogoIcon } from 'src/icons/php-logo-icon';
import { PythonLogoIcon } from 'src/icons/python-logo-icon';
import { RubyLogoIcon } from 'src/icons/ruby-logo-icon';
import { SAVED_LANGUAGES } from 'src/utils/constants';
import { useCodeBlockLanguage } from './code-block-language-provider';
type Language = Exclude<(typeof SAVED_LANGUAGES)[number], 'curl'>;
interface LanguageSelectorProps {
  languages?: Language[];
  children?: React.ReactNode;
}
export const LanguageSelector: React.FC<Readonly<LanguageSelectorProps>> = ({
  languages = ['js', 'ruby', 'python', 'go', 'php', 'laravel', 'java', 'dotnet'],
  // Default to showing all
  children
}) => {
  const [preferredLanguage, setPreferredLanguage] = useCodeBlockLanguage();
  const value = preferredLanguage === 'curl' ? undefined : preferredLanguage;
  return <>
      <RadioCards.Root columns={{
      initial: '2',
      xs: '3',
      md: '4'
    }} gap={{
      initial: '3',
      sm: '4'
    }} value={value} onValueChange={value => setPreferredLanguage(value)} data-sentry-element="RadioCards.Root" data-sentry-source-file="language-selector.tsx">
        {languages.includes('js') && <RadioCards.Item value="js">
            <Flex align="center" flexGrow="1" gap="3">
              <NodeJsLogoIcon height="24" width="24" />
              Node.js
            </Flex>
          </RadioCards.Item>}
        {languages.includes('ruby') && <RadioCards.Item value="ruby">
            <Flex align="center" flexGrow="1" gap="3">
              <RubyLogoIcon height="24" width="24" />
              Ruby
            </Flex>
          </RadioCards.Item>}
        {languages.includes('python') && <RadioCards.Item value="python">
            <Flex align="center" flexGrow="1" gap="3">
              <PythonLogoIcon height="24" width="24" />
              Python
            </Flex>
          </RadioCards.Item>}
        {languages.includes('go') && <RadioCards.Item value="go">
            <Flex align="center" flexGrow="1" gap="3">
              <GoLogoIcon height="24" width="24" />
              Go
            </Flex>
          </RadioCards.Item>}
        {languages.includes('php') && <RadioCards.Item value="php">
            <Flex align="center" flexGrow="1" gap="3">
              <PhpLogoIcon height="24" width="24" />
              PHP
            </Flex>
          </RadioCards.Item>}
        {languages.includes('laravel') && <RadioCards.Item value="laravel">
            <Flex align="center" flexGrow="1" gap="3">
              <LaravelLogoIcon height="24" width="24" />
              Laravel
            </Flex>
          </RadioCards.Item>}
        {languages.includes('java') && <RadioCards.Item value="java">
            <Flex align="center" flexGrow="1" gap="3">
              <JavaLogoIcon height="24" width="24" />
              Java
            </Flex>
          </RadioCards.Item>}
        {languages.includes('dotnet') && <RadioCards.Item value="dotnet">
            <Flex align="center" flexGrow="1" gap="3">
              <DotNetLogoIcon height="24" width="24" />
              .NET
            </Flex>
          </RadioCards.Item>}
      </RadioCards.Root>

      <Text as="p" color="gray" mb="6" mt="4" size="2" data-sentry-element="Text" data-sentry-source-file="language-selector.tsx">
        Don't see an SDK you need?{' '}
        <Link href="mailto:support@workos.com" data-sentry-element="Link" data-sentry-source-file="language-selector.tsx">Contact us</Link> to request an
        SDK!
      </Text>

      {value && children}
    </>;
};